import { useTheme } from 'styled-components';
import TimerIcon from '../../assets/icons/timer.svg?react';
import { useMeetTimer } from './useMeetTimer';
import { TimerContainer, TimerText } from './style';

export interface MeetTimerProps {
	startDate?: string;
	duration?: number;
}

export function MeetTimer({ startDate, duration }: Readonly<MeetTimerProps>) {
	const theme = useTheme();
	const { remainingTime, isLessThanTwoMinutes } = useMeetTimer(startDate, duration);

	const iconColor = isLessThanTwoMinutes ? theme.colors.error[300] : theme.colors.brand.primary[300];
	const textColor = isLessThanTwoMinutes ? theme.colors.error[300] : theme.colors.brand.primary[300];

	return (
		<TimerContainer data-testid="meet-timer">
			<TimerIcon fill={iconColor} width={18} height={21} data-testid="meet-timer_icon" />
			<TimerText $color={textColor} data-testid="meet-timer_text">{remainingTime}</TimerText>
		</TimerContainer>
	);
}

